export default "<highcharts-chart [Highcharts]=\"Highcharts\" [options]=\"chartOptions\" class=\"graph\"></highcharts-chart>";